import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import UserApplicationRoleModel from '../../../models/UserApplicationRoleModel';
import DataService from "../../../services/data.service";
import { UserProps } from '../../../types/IdProps';
import ApplicationRole_popup_AddUser from '../Popups/ApplicationRole_popup_AddUser';

export interface Props {
    applicationRoleId: number
}

const ApplicationRole_tab_Users: React.FC<Props> = ({ applicationRoleId }) => {
    const [data, setData] = useState<UserApplicationRoleModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [applicationRoleId]);

    function getTableData() {
        DataService.get<UserApplicationRoleModel[]>('api/v1/UserApplicationRoles/ByApplicationRole/' + applicationRoleId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/UserApplicationRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'User', dataProp: 'user.name', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditApplicationRoleForUser)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtApplicationRoleUsers'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='User'
                navigateUrl='/plm/UserManagement/User/'
            />
            {showPopup && <ApplicationRole_popup_AddUser applicationRoleId={applicationRoleId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}

        </>
    );
}
export default ApplicationRole_tab_Users;